// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1nBjz","savePackageButton":"ClientWallet_savePackageButton__3KSZN"};